import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const AlertSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper mr-2"
      style={style}
    >
      <svg className="w-100 h-100 img-fluid" fill={color} xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 64 64">
        <g>
          <path d="M35.99,14.34h-7.97c-0.55,0-1.07,0.22-1.45,0.62c-0.37,0.39-0.57,0.92-0.55,1.47l0.82,18.39c0.05,1.07,0.93,1.91,2,1.91   h6.33c1.07,0,1.95-0.84,2-1.91l0.82-18.39c0.02-0.55-0.18-1.08-0.56-1.47C37.06,14.56,36.53,14.34,35.99,14.34z" />
          <path d="M15.03,15.03c0.78-0.78,0.78-2.05,0-2.83c-0.78-0.78-2.04-0.78-2.82,0c-10.92,10.92-10.92,28.68,0,39.6   c0.39,0.39,0.9,0.58,1.41,0.58s1.02-0.19,1.41-0.58c0.78-0.78,0.78-2.05,0-2.83C5.68,39.61,5.68,24.39,15.03,15.03z" />
          <circle cx="32" cy="44.22" r="5.44" />
          <path d="M20.69,17.86c-0.78-0.79-2.05-0.79-2.83,0c-3.77,3.77-5.85,8.79-5.85,14.14c0,5.35,2.08,10.37,5.85,14.14   c0.39,0.39,0.9,0.59,1.42,0.59c0.51,0,1.02-0.2,1.41-0.59c0.78-0.78,0.78-2.05,0-2.83c-3.02-3.01-4.68-7.03-4.68-11.31   c0-4.28,1.66-8.3,4.68-11.32C21.47,19.9,21.47,18.64,20.69,17.86z" />
          <path d="M46.15,17.86c-0.79-0.79-2.05-0.79-2.83,0c-0.78,0.78-0.78,2.04,0,2.82C46.33,23.7,48,27.72,48,32   c0,4.28-1.67,8.3-4.68,11.31c-0.78,0.78-0.78,2.05,0,2.83c0.39,0.39,0.9,0.59,1.41,0.59s1.02-0.2,1.42-0.59   C49.92,42.37,52,37.35,52,32C52,26.65,49.92,21.63,46.15,17.86z" />
          <path d="M51.8,12.2c-0.78-0.78-2.04-0.78-2.83,0c-0.78,0.78-0.78,2.05,0,2.83c9.36,9.36,9.36,24.58,0,33.94   c-0.78,0.78-0.78,2.05,0,2.83c0.4,0.39,0.91,0.58,1.42,0.58c0.51,0,1.02-0.19,1.41-0.58C62.72,40.88,62.72,23.12,51.8,12.2z" />
        </g>
      </svg>
    </span>
  );
};

AlertSVG.defaultProps = {
  color: getComputedCSSVariable('blue-600'),
  style: {
    width: '14px',
    height: '14px',
  },
};

export default AlertSVG;
